import LazyLoadOnScroll from "@Components/LazyLoadOnScroll";
import { getIconName } from "../../RoomTypeSection/utils";
import styles from "./ScrollStyles.module.scss";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import config from "@Config/index";
import useIsApp from "hooks/useIsApp";

type TagsScrollPropType = {
  data?: any;
  mapTags?: any;
};

const TagsScroll = ({ data, mapTags }: TagsScrollPropType) => {
  const { t } = useTranslationHook();
  const isApp = useIsApp();

  const isChinaAndApp = isApp || config.IS_CHINA_APP;
  // Check if this badge should be highlighted (Pay in Instalment or No Visa No Pay)
  const lowerData = typeof data === "string" ? data.toLowerCase() : "";
  const isHighlighted =
    lowerData.includes("pay in installment") ||
    lowerData.includes("pay in instalment") ||
    lowerData.includes("installments") ||
    lowerData.includes("instalments") ||
    lowerData.includes("no visa no pay");

  return (
    <>
      {data?.place !== "" ? (
        <div className={styles.parentContainer}>
          <div
            className={formatClassNames(
              styles.journeyContainer,
              isHighlighted && (isChinaAndApp ? styles.chinaHighlighted : styles.highlighted),
            )}
          >
            <div className={styles.iconContainer}>
              <LazyLoadOnScroll
                customRootMargin="0px"
                fallback={
                  <section
                    style={{
                      height: "14px",
                      width: "14px",
                    }}
                  />
                }
              >
                {getIconName(mapTags?.[data] || data)}
              </LazyLoadOnScroll>
            </div>
            <div className={styles.info}>
              <div data-testid="property-policy" className={styles.cityName}>
                {t(data)}
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default wrapperHOC(TagsScroll, {
  componentName: "TagsScroll-PropertyDetailsSection-PropertyPage",
  showForChina: true,
});
